<template>
  <main role="main" class="d-flex flex-column align-items-center justify-content-center py-5">
    <b-row v-if="!successMessage" no-gutters class="box border rounded">
      <b-col cols="6" class="left-item position-relative">
        <div class="position-absolute text-center w-100 px-3" style="top: 2rem;">
          <h4>{{ $t("registerAccount") }}</h4>
          <p>{{ $t("registerAccountSubtitle") }}</p>
        </div>
        <div class="position-absolute" style="bottom: 2rem; left: 50%; transform: translateX(-50%)">
          {{ $t("alreadyHaveAccountQ") }} <router-link to="/login">{{ $t("login") }}</router-link>
        </div>
      </b-col>
     
      <b-col cols="6" class="p-5">
        <b-form class="mb-3" novalidate @keydown="formKeyDown" @submit.prevent="onSubmit">
          <b-form-group>
            <template v-slot:label>Email <span class="text-danger">*</span></template>
            <b-input-group>
              <b-form-input type="email" name="email" required v-model="email"/>
            
              <b-input-group-append>
                <b-input-group-text>
                  <span class="fas fa-envelope"></span>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-checkbox class="mb-3" v-model="agreeTerms" name="agreeTerms">
            {{ $t("signUpIAgreeWith") }}
            <a href="/dieu-khoan.html" target="_blank">{{ $t("signUpTermOfUse") }}</a>
            {{ $t("and") }}
            <a href="/chinh-sach.html" target="_blank">{{ $t("signUpPrivacyPolicy") }}</a>
          </b-form-checkbox>
          <p v-if="formErrorMsg" class="text-danger">{{ $t(formErrorMsg) }}</p>
          <b-button type="submit" variant="primary" block :disabled="isSubmitting || !agreeTerms" @click="beforeSubmit">
            {{ $t("register") }}
          </b-button>
        </b-form>
      </b-col>
    </b-row>
    <div v-else class="box box-success text-center border rounded p-5">
      <h2 class="mb-4">{{ $t("verificationEmailSent") }}</h2>
      <p style="font-size: 20px; white-space: pre-wrap;">{{ successMessage }}</p>
      <div class="mb-2" style="font-size: 16px;">{{ $t("notGetVerificationEmailYetC") }}</div>
      <div class="mb-5"><span class="text-primary cursor-pointer" @click="resendEmail">{{ $t("resendVerificationEmail") }}</span></div>
      <div>
        <b-button class="email-btn mr-4" variant="outline-primary" href="https://mail.google.com/mail" target="_blank">{{ $t("openGmail") }}</b-button>
        <b-button class="email-btn" variant="outline-primary" href="https://outlook.live.com/mail" target="_blank">{{ $t("openOutlook") }}</b-button>
      </div>
    </div>
<!--    <b-button variant="link" @click="successMessage = successMessage? '' : $t('verificationEmailSentSubtitle')">Toggle</b-button>-->
  </main>
</template>

<style lang="scss" scoped>
  .box {
    flex-shrink: 0;
    width: 880px;
    height: 510px;
    box-shadow: 0px 4px 40px rgb(0 0 0 / 15%);
  }

  .box-success {
    background-repeat: no-repeat;
    background-image: url("~/public/images/arrow_blue.png");
    background-position: right 20% bottom 0%;
  }

  .left-item {
    background-color: #dae0e9;
    background-image: url("~/public/images/arrow2.png");
    background-position: left 176px;
    background-repeat: no-repeat;
    background-size: 338px;
    color: #595959;
  }

  .email-btn {
    width: 140px;
  }
</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as userService from "@/service/userService";
  import * as validationUtils from "@/service/validationUtils";

  @Component
  export default class SignUp extends BaseComponent {

    isLoading = true;
    email = "";
    agreeTerms = false;

    formErrorMsg = "";
    isSubmitting = false;
    successMessage = "";

    secretKey = "";
    isSecretKeyValid = false;

    async mounted() {
      this.secretKey = this.$route.query.secretKey as string;

      if (this.secretKey) {
        this.isSecretKeyValid = true;
        return;
      }
    }

    formKeyDown(event: KeyboardEvent) {
      return event.key !== 'Enter';
    }

    beforeSubmit() {
      this.email = this.email.trim();
    }

    async onSubmit() {
      this.formErrorMsg = null;

      if (!validationUtils.isEmail(this.email)) {
        this.formErrorMsg ="invalidEmail";
        return;
      }

      try {
        this.isSubmitting = true;
        const email = this.email;

        const verifyRet = await userService.verifyEmail(email, this.isSecretKeyValid, this.secretKey);
        this.successMessage = verifyRet?.message || this.$t("verificationEmailSentSubtitle", { email }).toString();

      } catch (e) {
        this.formErrorMsg = e.response?.data?.code || e.code;

      } finally {
        this.isSubmitting = false;
      }
    }

    async resendEmail() {
      try {
        this.showLoading();
        const email = this.email;
        await userService.verifyEmail(email, this.isSecretKeyValid, this.secretKey);
        this.toastSuccessDelay(this.$t("verificationEmailSent").toString());

      } catch (e) {
        this.formErrorMsg = e.response?.data?.code || e.code;
        this.toastError(e);

      } finally {
        this.hideLoading();
      }
    }

  }
</script>
